import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { GeneralServices, ServiceForm, ServiceFormPayload, ServicesHero } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'services',
    events: {
        'Load Services Hero': emptyProps(),
        'Load Services Hero Success': props<{ servicesHero: ServicesHero }>(),
        'Load Services Hero Failure': props<{ error: string }>(),

        'Load General Services': emptyProps(),
        'Load General Services Success': props<{ generalServices: GeneralServices }>(),
        'Load General Services Failure': props<{ error: string }>(),

        'Load Service Form': emptyProps(),
        'Load Service Form Success': props<{ serviceFormContent: ServiceForm }>(),
        'Load Service Form Failure': props<{ error: string }>(),

        'Submit Service Form': props<{ payload: ServiceFormPayload }>(),
        'Submit Service Form Response': props<{ success: boolean }>(),
        'Submit Service Form Loading': props<{ loading: boolean }>(),
    },
});
